import { render } from "./DropdownMenuSidebar.vue?vue&type=template&id=6d2a1b42"
import script from "./DropdownMenuSidebar.vue?vue&type=script&lang=js"
export * from "./DropdownMenuSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"webpack-assets/vue/templates/common/header/parts/DropdownMenuSidebar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6d2a1b42"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6d2a1b42', __exports__)) {
    api.reload('6d2a1b42', __exports__)
  }
  
  module.hot.accept("./DropdownMenuSidebar.vue?vue&type=template&id=6d2a1b42", () => {
    api.rerender('6d2a1b42', render)
  })

}


export default __exports__